import React from 'react';

export default function AngelWingsSvg({ size = 60, className = '' }) {
  return (
    <svg width={size} height={size * 0.8} viewBox="0 0 60 48" fill="none" className={className}>
      {/* Left wing */}
      <path
        d="M28 24C22 18 10 8 4 10C2 11 4 16 8 18C12 20 18 22 22 24C16 22 6 22 4 26C2 28 8 30 14 28C18 27 22 26 26 24"
        fill="white"
        opacity="0.9"
      />
      <path
        d="M26 26C20 26 10 28 8 30C6 32 12 32 18 30C22 28 24 27 26 26"
        fill="white"
        opacity="0.7"
      />
      {/* Right wing */}
      <path
        d="M32 24C38 18 50 8 56 10C58 11 56 16 52 18C48 20 42 22 38 24C44 22 54 22 56 26C58 28 52 30 46 28C42 27 38 26 34 24"
        fill="white"
        opacity="0.9"
      />
      <path
        d="M34 26C40 26 50 28 52 30C54 32 48 32 42 30C38 28 36 27 34 26"
        fill="white"
        opacity="0.7"
      />
      {/* Feather details */}
      <path d="M10 14L16 20" stroke="#E0E0E0" strokeWidth="0.5" />
      <path d="M8 20L14 24" stroke="#E0E0E0" strokeWidth="0.5" />
      <path d="M50 14L44 20" stroke="#E0E0E0" strokeWidth="0.5" />
      <path d="M52 20L46 24" stroke="#E0E0E0" strokeWidth="0.5" />
    </svg>
  );
}
